import { useState, useEffect, useContext, FormEvent } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { listarTarefas, deletarTarefa } from '../../services/tasks'
import { listarMembrosProjeto } from '../../services/projetos'
import { usuariosRespostaPayload } from '../../interfaces/usuarios'
import { ModalEstadoContext } from '../../contexts/ModalEstado'
import { Button, Loader } from '../Styles'
import { toast } from 'react-toastify'
import { TarefasProjeto } from '../../interfaces/projetos'
import ModalTarefas from '../ModalTarefas'
import Perfil from '../../middleware/Perfil'
import FiltrosDefault from '../FiltrosDefault'
import avatarDefault from '../../assets/img/avatarDefault.png'
import apagarImg from '../../assets/img/excluir.png'
import DivSituacao from '../DivSituacao'
import maisFiltrosImg from '../../assets/img/maisFiltros.png'
import LoagindBarra from '../LoadingBarra'
import LoadingCirculo from '../LoadingCirculo'
import NenhumResultadoEncontrado from '../NenhumResultadoEncontrato'
import '../../styles/paginaListaDados.css'
import './tasks.css'


function Tasks () {

    const { modalExibir, modal, atualizarDados, atualizarInformacoes } = useContext(ModalEstadoContext)

    const navigate = useNavigate()
    const location = useLocation()

    const { pathname, search } = location

    const paramsUrl = new URLSearchParams(search)

    const idProjeto = paramsUrl.get("idProjeto")
    const grupo = paramsUrl.get('grupo')
    const minhasSolicitacoes = paramsUrl.get('minhasSolicitacoes')
    const solicitacaoAprovacao = paramsUrl.get('solicitacaoAprovacao')
    const usuarioLogado = localStorage.getItem('usuarioGesttor')

    const data = new Date()

    const ano = data.getFullYear()
    const qtnDias = new Date (data.getFullYear(), data.getMonth() + 1, 0).getDate()
    const dataAnterior = new Date (new Date().setDate(new Date().getDate() - 60))
    
    const dataInicial = `${dataAnterior.getFullYear()}-${(dataAnterior.getMonth() + 1).toString().padStart(2, '0')}-01`
    const dataFinal = `${ano}-${(data.getMonth() + 1).toString().padStart(2, '0')}-${qtnDias}`

    const [tarefas, setTarefas] = useState<TarefasProjeto[]>([])
    const [tarefaSelecionada, setTarefaSelecionada] = useState<TarefasProjeto>()
    const [resposaveis, setResponsaveis] = useState<usuariosRespostaPayload[]>([])
    const [maisFiltros, setMaisFiltros] = useState(false)
    const [maisTarefas, setMaisTarefas] = useState(false)
    const [pagina, setPagina] = useState(2)
    const [responsavel, setResponsavel] = useState('')
    const [titulo, setTitulo] = useState('')
    const [descricao, setDescricao] = useState('')
    const [dataInicio, setDataInicio] = useState(dataInicial)
    const [dataTermino, setDataTermino] = useState(dataFinal)
    const [situacao, setSituacao] = useState('')
    const [tipo] = useState('tarefa')
    const [processando, setProcessando] = useState(false)
    const [nenhumResultado, setNenhumResultado] = useState(false)

    const exibirModaltarefas = () => modalExibir('ModalTarefa')

    const modalMaisFiltros = () => setMaisFiltros(!maisFiltros)

    const scrollInfinito = (e: any) => {

        const { scrollTop, clientHeight, scrollHeight } = e.target;

        const posicaoScroll = (scrollTop/(scrollHeight - clientHeight)*100)

        if (posicaoScroll >= 90) {

            setPagina(prevtState => prevtState + 1)

            const buscarMaisTarefas = async () => {

                setMaisTarefas(true)

                if(!idProjeto) return toast.error('Projeto não Localizado')

                const params = {
                    idProjeto,
                    pagina,
                    titulo,
                    descricao,
                    situacao,
                    dataInicio,
                    dataTermino,
                    responsavel,
                    minhasSolicitacoes
                }

                try {

                    const resposta = await listarTarefas(params)

                    if (resposta.status === 200) {
                        setTarefas(prevDate => [...prevDate, ...resposta.data])
                        return setMaisTarefas(false)
                    }
            
                } catch (error) {
                    setMaisTarefas(false)

                    return toast.error('Falha ao Buscar Mais Tarefas')
                }
            }

            buscarMaisTarefas()
        }
    }

    const exibirModalDadosTarefas = (tarefa: TarefasProjeto, idTarefa: number) => {

        if(minhasSolicitacoes) {
            navigate(`${pathname}?minhasSolicitacoes=true&idTarefa=${idTarefa}&idProjeto=${idProjeto}&grupo=${grupo}`)
            modalExibir('ModalTarefa')

            return setTarefaSelecionada(tarefa)
        }

        if(solicitacaoAprovacao) {
            navigate(`${pathname}?solicitacaoAprovacao=true&idTarefa=${idTarefa}&idProjeto=${idProjeto}&grupo=${grupo}`)
            modalExibir('ModalTarefa')

            return setTarefaSelecionada(tarefa)
        }

        navigate(`${pathname}?idTarefa=${idTarefa}&idProjeto=${idProjeto}&grupo=${grupo}`)
        modalExibir('ModalTarefa')

        return setTarefaSelecionada(tarefa)
    }

    const buscarTarefas = async (e: FormEvent) => {

        e.preventDefault()
        setMaisFiltros(false)
        setNenhumResultado(false)
        setProcessando(true)

        if(!idProjeto) return toast.error('Projeto não Localizado')

        const params = {
            idProjeto,
            pagina: 1,
            titulo,
            descricao,
            situacao,
            dataInicio,
            dataTermino,
            responsavel,
            minhasSolicitacoes,
            ...(solicitacaoAprovacao && { idUsuarioAprovador: usuarioLogado }),
        }

        try {

            const resposta = await listarTarefas(params)


            if (resposta.data.length === 0) {
                setTarefas(resposta.data)
                setProcessando(false)
                return setNenhumResultado(true)
            }

            if (resposta.status === 200) {
                setTarefas(resposta.data)

                return setProcessando(false)
            }
            
        } catch (error) {

            setProcessando(false)
            return toast.error('Falha ao Listar as Tarefas')
        }
    }

    const deletarTask = async (idTarefa: number) => {

        setProcessando(true)

        try {

            const resposta = await deletarTarefa(idTarefa)

            if(resposta.status === 200) {
                setProcessando(false)
                toast.success('Tarefa Deletada com Sucesso')
                atualizarDados()

                return 
            }
            
        } catch (error) {

            return toast.error('Falha ao Deletar a Tarefa')
            
        }

    }
    
    useEffect(() => {
        if(modal.nome === '') return setTarefaSelecionada(undefined)
    }, [modal.nome])
    
    useEffect(() => {
        
        const buscarTarefas = async () => {

            setNenhumResultado(false)
            setProcessando(true)

             if(!idProjeto) return toast.error('Projeto não Localizado')

            const params = {
                idProjeto,
                pagina: 1,
                titulo,
                descricao,
                situacao: '',
                responsavel,
                dataInicio: dataInicial,
                dataTermino: dataFinal,
                minhasSolicitacoes,
                ...(solicitacaoAprovacao && { idUsuarioAprovador: usuarioLogado }),
            }

            try {

                const resposta = await listarTarefas(params)

                if (resposta.data.length === 0) {
                    setTarefas(resposta.data)
                    setProcessando(false)
                    return setNenhumResultado(true)
                }

                if (resposta.status === 200) {
                    setTarefas(resposta.data)
                    return setProcessando(false)
                }
                
            } catch (error) {
                
            }
        }

        buscarTarefas ()

    }, [atualizarInformacoes, minhasSolicitacoes, solicitacaoAprovacao])

    useEffect(() => {

        const listarMembrosResponsaveis = async () => {

            if (!idProjeto) return toast.error("Não foi possivel encontrar o projeto.")

            try {
                
                const resposta = await listarMembrosProjeto(idProjeto)

                setResponsaveis(resposta.data)
                
                return
            } catch (error) {

                toast.error("Erro ao listar todos os membros do Projeto.")
            }
        }

        listarMembrosResponsaveis()

    }, [idProjeto])


    return (
        <div id='paginaContainer'>
            {modal.nome === "ModalTarefa" && <ModalTarefas tarefa={tarefaSelecionada}/>}
            {processando && <LoagindBarra />}
            {nenhumResultado && <NenhumResultadoEncontrado />}
            <FiltrosDefault termo={titulo} situacao={situacao} placeholder='Pesquise pelo título da tarefa' tipo={tipo} onChangeTermo={(e) => setTitulo(e.target.value)} onChangeSituacao={(e) => setSituacao(e.target.value)} onSubmit={buscarTarefas} acaoBtn={exibirModaltarefas} listaSituacao={[{nome: 'Todas', valor: ''}, {nome: 'Pendentes', valor: 'pendente'}, {nome: 'Atrasadas', valor: 'atrasada'}, {nome: 'Concluídas', valor: 'concluída'}]} genero='feminino' maisFiltros={true} acaoMaisFiltro={modalMaisFiltros} isLoading={processando}/>

            {maisFiltros && <section id='maisOpcoesFiltrosTarefas'>
                <form id='maisOpcoesFiltrosTarefasContainer' onSubmit={buscarTarefas}>
                    <span id='filtrosContainerTitulo'>
                        <img id='filtrosAvancadosTarefas' src={maisFiltrosImg}  alt=''/>
                        <p>Filtros Avançados</p>
                    </span>
                    <section id='opcoesFiltrosTarefas'>
                        <section>
                            {search && minhasSolicitacoes && <span>
                                <label htmlFor="responsaveltarefa">Responsável</label>
                                <select id='responsaveltarefa' value={responsavel} onChange={(e) => setResponsavel(e.target.value)}>
                                    <option value=""></option>
                                    {resposaveis.map((responsavel) => (
                                        <option key={responsavel.usuario.id} value={responsavel.usuario.id}>{responsavel.usuario.nome}</option>
                                    ))}
                                </select>
                            </span>}
                            {search !== '?automaticas=true' && <span>
                                <label htmlFor="dataInicialFiltrotarefas">Data Inicial</label>
                                <input 
                                    id="dataInicialFiltrotarefas"
                                    type="date" 
                                    value={dataInicio}
                                    onChange={(e) => setDataInicio(e.target.value)}/>
                            </span>}

                            {search !== '?automaticas=true' && <span>
                                <label htmlFor="dataFinalFiltrotarefas">Data Final</label>
                                <input 
                                    id="dataFinalFiltrotarefas"
                                    type="date" 
                                    value={dataTermino}
                                    onChange={(e) => setDataTermino(e.target.value)}/>
                            </span>}
                        </section>

                        <section>
                            <span>
                                <label htmlFor="tituloTarefaFiltro">Título da Tarefa</label>
                                <input 
                                    id='tituloTarefaFiltro'
                                    type="text" 
                                    value={titulo}
                                    placeholder='Pesquise pelo título da tarefa'
                                    onChange={(e) => setTitulo(e.target.value)}/>
                            </span>

                            {search !== '?automaticas=true' && <span>
                                <label htmlFor="situacaoFiltroTarefa">Situação</label>
                                <select id="situacaoFiltroTarefa" value={situacao} onChange={(e) => setSituacao(e.target.value)}>
                                    <option value="">Todas</option>
                                    <option value="pendente">Pendentes</option>
                                    <option value="atrasada">Atrasadas</option>
                                    <option value="concluída">Conclúidas</option>
                                </select>
                            </span>}
                        </section>
                        
                        <section>
                            <span>
                                <label htmlFor="descricaoTarefaFiltro">Descrição da Tarefa</label>
                                <input
                                    id='descricaoTarefaFiltro' 
                                    type="text" 
                                    value={descricao}
                                    placeholder='Pesquise pela descrição da tarefa'
                                    onChange={(e) => setDescricao(e.target.value)}/>
                            </span>
                        </section>
                    </section>

                    <span id="botoesContainerFiltrosTarefas">
                        <Button type='button' cor='cancelar' isLoading={processando} onClick={modalMaisFiltros}>Cancelar</Button>
                        <Button type='submit' cor='salvar' isLoading={processando}>
                            {!processando && 'Buscar Dados'}
                            {processando && <Loader isLoading={processando}/>}
                        </Button>
                    </span>
                </form>
            </section>}

            <section id='fundoContainerPagina' onScroll={scrollInfinito}>
                <table id='tabelaListaContainer'>
                    <thead>
                        <tr>
                            <th id='ladoEsquerdoContent' align='left'>Título</th>
                            <th id='responsavelTarefa' align='left'>Responsável</th>
                            <th align='center'>Prazo</th>
                            <th id='prioridadeTarefa' align='center'>Prioridade</th>
                            <th align='center'>Situação</th>
                            <Perfil perfil={['master', 'consultor']}>
                                <th>Ação</th>
                            </Perfil>
                        </tr>
                    </thead>
                    <tbody>
                        {tarefas.map((tarefa) => (
                            <tr key={tarefa.id}>
                                <td id='primeiraColuna' onClick={() => exibirModalDadosTarefas(tarefa, tarefa.id)}>{tarefa.titulo}</td>
                                <td id='usuarioResponsavelTarefaContent' onClick={() => exibirModalDadosTarefas(tarefa, tarefa.id)}>
                                    <img id='usuarioResponsavelTarefa' src={tarefa.usuarioResponsavel.avatar ? tarefa.usuarioResponsavel.avatar : avatarDefault} alt='' />
                                    {tarefa.usuarioResponsavel.nome}
                                </td>
                                <td align='center' onClick={() => exibirModalDadosTarefas(tarefa, tarefa.id)}>{`${tarefa.dataEntrega.slice(8,10)}-${tarefa.dataEntrega.slice(5,7)}-${tarefa.dataEntrega.slice(0,4)}`}</td>
                                <td id='prioridadeTarefa' align='center' onClick={() => exibirModalDadosTarefas(tarefa, tarefa.id)}>
                                    <DivSituacao texto={`${tarefa.prioridade.charAt(0).toUpperCase()}${tarefa.prioridade.substring(1)}`}cor={tarefa.prioridade} />
                                </td>
                                <td align='center' onClick={() => exibirModalDadosTarefas(tarefa, tarefa.id)}>
                                    <DivSituacao texto={`${tarefa.situacao.charAt(0).toUpperCase()}${tarefa.situacao.substring(1)}`} cor={tarefa.situacao}/>
                                </td>
                                <Perfil perfil={['master']}>
                                    <td id='ladoDireitoContent' align='center'>
                                        {tarefa.situacao !== 'concluída' ? <img id='apagarIconeTarefa' title='Excluir Tarefa' src={apagarImg} alt='' onClick={() => deletarTask(tarefa.id)}/> : null}
                                    </td>
                                </Perfil>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {maisTarefas && <div id='buscarMaisDados'>
                    <LoadingCirculo />
                </div>}
            </section>
        </div>
    )
}

export default Tasks
